; (function () {
	"use strict";
	function ServiceCardsSlider() {
		var global = {
			cards: false
		};

		var fn = {
			init: function () {
				fn.initSliders();
				fn.setupSliderCards();
				fn.bindResize(); // listen to window resize
			},

			initSliders: function() {
				jQuery('.service-cards .splide').each(function(index, element) {
					fn.initSlider(element);
				})
			},

			initSlider: function (element) {
				let splide = new Splide(element, {
					perPage: 1,
					fixedWidth: '274px',
					perMove: 1,
					gap: '16px',
					type: 'slide',
					pagination: false,
					arrows: false,
					mediaQuery: 'min',
					breakpoints: {
						1000: {
							destroy: true,
						},
						800: {
							perPage: 2,
							fixedWidth: '288px',
							gap: '28px',
						},
						320: {}
					}
				}).mount();

				let prevButton = element.querySelector('.service-cards__nav-button--prev');
				let nextButton = element.querySelector('.service-cards__nav-button--next');

				// Add event listeners
				prevButton.addEventListener('click', function () {
					splide.go('<'); // Move to the previous slide
				});
				nextButton.addEventListener('click', function () {
					splide.go('>'); // Move to the next slide
				});
			},

			setupSliderCards: function() {
				var cardGrids = jQuery('.service-cards .bm-cards__grid');

				if (!cardGrids.length) {
					return;
				}

				var windowWidth = jQuery(window).width();
				if (windowWidth >= 1000) {
					// Clear heights when switching back to desktop
					cardGrids.each(function(i, cardGrid) {
						jQuery(cardGrid).find('.service-cards__icon, .bm-card__heading, .bm-card__teaser').css('min-height', '');
					});
					return;
				}

				cardGrids.each(function(i, cardGrid) {
					global.cards = jQuery(cardGrid).find('.bm-card');
					fn.equaliseHeights(global.cards);
				});
			},

			equaliseHeights: function(row) {
				var icons = jQuery(row).find('.service-cards__icon');
				var headings = jQuery(row).find('.bm-card__heading');
				var teasers = jQuery(row).find('.bm-card__teaser');
				var elementGroups = [icons, headings, teasers];

				jQuery(elementGroups).each(function(i, elementGroup) {
					var largestElement = fn.getLargestHeight(elementGroup);

					elementGroup.each(function(i, element) {
						jQuery(element).css('min-height', largestElement);
					});
				});
			},

			getLargestHeight: function(elems)
			{
				var largest = 0;
				elems.each(function(i, elem) {
					var elemHeight = jQuery(elem).height();
					if (elemHeight > largest)
					{
						largest = elemHeight;
					}
				});

				return largest;
			},

			bindResize: function() {
				jQuery(window).on('resize orientationchange', function() {
					fn.setupSliderCards(); // re-run on resize/orientation change
				});
			}

		}
		jQuery(document).ready(fn.init);
	}
	new ServiceCardsSlider();
})();